import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const LOAD_PUBLISH_TERMS = 'PUBLISH_TERMS :: LOAD';

export type TLoadPublishTermsAction = IReduxAction<typeof LOAD_PUBLISH_TERMS>;

export const loadPublishTerms = actionGenerator<typeof LOAD_PUBLISH_TERMS>(LOAD_PUBLISH_TERMS);
